import React, { useState } from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Chip,
    Card,
    CardContent,
    Link,
    Button,
    Avatar
} from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import LaunchIcon from '@mui/icons-material/Launch';

const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
        const offset = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;
        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
};

const PostContent = () => {
    const [showToc, setShowToc] = useState(true);
    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', px: 3 }}>
            {showToc ? (
                <Card sx={{ mb: 4, boxShadow: 2, bgcolor: '#e3f2fd', border: '1px solid #ddd', borderRadius: 2 }}>
                    <CardContent sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <Typography variant="h6" sx={{ flexGrow: 1 }}>目次</Typography>
                            <Button variant="outlined" size="small" onClick={() => setShowToc(false)}>閉じる</Button>
                        </Box>
                        <List sx={{ p: 0 }}>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    1.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('introduction')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    ルームシェア「住み替え」の魅力と背景
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    2.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('trigger')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    住み替えのきっかけとは？
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    3.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('tips')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    住み替え成功のコツ＆ステップ
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    4.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('experience')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    体験談：私たちの住み替えストーリー
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    5.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('fail')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    失敗しないためのポイント
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    6.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('summary')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    まとめ＆次のステップ
                                </Link>
                            </ListItem>
                        </List>
                    </CardContent>
                </Card>
            ) : (
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowToc(true)}
                    sx={{ mb: 2 }}
                >
                    目次を表示
                </Button>
            )}

            {/* 導入部分 */}
            <Box id="introduction" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    ルームシェア住み替えの魅力と可能性
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    ルームシェアは、住まいに新しい価値観や可能性をもたらしてくれます。そんな中、「住み替え」はより自分らしい暮らしへの一歩を踏み出すきっかけとなる選択肢です。実際に住み替えを経験した人たちの声からは、想像以上の発見や成長、そして新たな人間関係の広がりが伝わってきます。
                </Typography>

                <Typography variant="body2" color="text.secondary">
                    住み替えは単なる「引っ越し」ではなく、新しい自分と出会うチャンスでもあります。このブログでは、住み替えを検討している方や今まさに悩んでいる方に向けて、体験談を交えながら、きっかけや成功のコツ、失敗しないためのポイントをお伝えします。
                </Typography>
            </Box>

            {/* 住み替えのきっかけ */}
            <Box id="trigger" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <SwapHorizIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
                    住み替えのきっかけとは？
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    ルームシェアの住み替えを考えるきっかけは人それぞれ。実際によくある主なきっかけをまとめてみました。
                </Typography>
                <List>
                    <ListItem>
                        <ListItemIcon><LightbulbIcon color="primary" /></ListItemIcon>
                        <ListItemText
                            primary="ライフステージや働き方の変化"
                            secondary="転職や独立、学業の区切りなど、環境や価値観の変化が新たな住まいを求める動機に。"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon><HomeIcon color="secondary" /></ListItemIcon>
                        <ListItemText
                            primary="より快適な住空間を求めて"
                            secondary="設備や立地、家賃バランスの見直し。理想の生活スタイルへのアップデート。"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon><MenuBookIcon color="action" /></ListItemIcon>
                        <ListItemText
                            primary="ルームメイトの変更や人間関係"
                            secondary="新たな出会いを求めて、または今の人間関係をリセットしたくて。"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon><ErrorOutlineIcon color="warning" /></ListItemIcon>
                        <ListItemText
                            primary="トラブルや生活リズムの違い"
                            secondary="夜型・朝型の違いや生活音、清潔感などでストレスを感じたとき。"
                        />
                    </ListItem>
                </List>
                <Box sx={{ mt: 2 }}>
                    <Chip label="Step Up" color="primary" variant="outlined" sx={{ mr: 1 }} />
                    <Chip label="Change" color="secondary" variant="outlined" sx={{ mr: 1 }} />
                    <Chip label="New Life" color="success" variant="outlined" />
                </Box>
            </Box>

            {/* 住み替えのコツ＆ステップ */}
            <Box id="tips" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <LightbulbIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
                    住み替え成功のコツ＆ステップ
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Paper elevation={2} sx={{ p: 3, borderRadius: 2, bgcolor: '#fafafa', mb: 2 }}>
                    <Typography variant="h6" sx={{ mb: 2 }}>
                        住み替えの流れをしっかり押さえよう
                    </Typography>
                    <List>
                        <ListItem>
                            <ListItemIcon>
                                <CheckCircleIcon color="success" />
                            </ListItemIcon>
                            <ListItemText
                                primary="① 住み替えの目的を明確にする"
                                secondary="「なぜ住み替えたいのか？」を言語化することで、物件選びや交渉がスムーズに。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <CheckCircleIcon color="success" />
                            </ListItemIcon>
                            <ListItemText
                                primary="② 新しい住まいの条件をリストアップ"
                                secondary="家賃、場所、部屋の広さ、共用設備、ルームメイト像など優先順位を明確に。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <CheckCircleIcon color="success" />
                            </ListItemIcon>
                            <ListItemText
                                primary="③ 情報収集と内見の徹底"
                                secondary="複数のサイトやSNS、専門コミュニティを活用し、気になる物件は必ず現地でチェック。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <CheckCircleIcon color="success" />
                            </ListItemIcon>
                            <ListItemText
                                primary="④ ルームメイトとの相性を確認"
                                secondary="面談やオンラインミーティングで生活観や価値観をすり合わせるのが重要。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <CheckCircleIcon color="success" />
                            </ListItemIcon>
                            <ListItemText
                                primary="⑤ 契約・引っ越し準備は計画的に"
                                secondary="退去・入居のスケジュール調整や、荷物整理、現住居のクリーニングも忘れずに。"
                            />
                        </ListItem>
                    </List>
                </Paper>

                <Typography variant="body2" color="text.secondary">
                    住み替えは慌てず、段階的に進めることが成功への近道。自分の理想と現実のバランスを冷静に見極めましょう。
                </Typography>
            </Box>

            {/* 体験談 */}
            <Box id="experience" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <MenuBookIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
                    体験談：私たちの住み替えストーリー
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={3} sx={{ mb: 2 }}>
                    <Grid item xs={12} md={7}>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            私（Mさん）が住み替えを決断したのは、転職により通勤時間が大幅に増えたことがきっかけでした。<br />
                            以前の物件でもルームメイトとも円満に過ごしていましたが、毎日の往復2時間はやはり負担。そこで新しいエリアでのルームシェアにチャレンジすることに。<br /><br />
                            <b>【住み替えの過程で感じたこと】</b><br />
                            <ul>
                                <li>内見では「写真」と「実際の空間」のギャップが大きいことに驚き。</li>
                                <li>新しいルームメイトとのコミュニケーションは最初こそ緊張したが、共通の趣味（料理や映画）を通じてすぐに打ち解けた。</li>
                                <li>住み替えを通じて、自分に本当に合った生活スタイルや人間関係が見えてきた。</li>
                            </ul>
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <Box
                            component="img"
                            src="/images/blog/new-roommates_roomshare-sumikkae-taikendan.jpg"
                            alt="新しいキッチンで料理を楽しむ3人のルームメイト。明るい自然光とナチュラルな内装が特徴的な空間で、住み替えによる新たな日常の始まりを象徴する写真"
                            sx={{ width: '100%', borderRadius: 2, boxShadow: 1 }}
                        />
                    </Grid>
                </Grid>
                <Paper elevation={1} sx={{ p: 2, bgcolor: '#f5fafd', borderRadius: 2 }}>
                    <Typography variant="h6" sx={{ mb: 1 }}>
                        住み替え前後の変化
                    </Typography>
                    <List dense>
                        <ListItem>
                            <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
                            <ListItemText primary="通勤が楽になり、平日の自由時間が増加" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
                            <ListItemText primary="価値観が近い仲間と出会え、ストレスが激減" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
                            <ListItemText primary="自分の「居場所」がよりクリアに感じられるように" />
                        </ListItem>
                    </List>
                </Paper>
            </Box>

            {/* 失敗しないポイント */}
            <Box id="fail" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <ErrorOutlineIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
                    失敗しないためのポイント
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Paper elevation={2} sx={{ p: 3, borderRadius: 2, bgcolor: '#fff7f0', mb: 2 }}>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                        住み替えはワクワクする反面、思わぬ落とし穴も。次のポイントを押さえておけば、後悔しない住み替えが実現できます。
                    </Typography>
                    <List>
                        <ListItem>
                            <ListItemIcon><ErrorOutlineIcon color="error" /></ListItemIcon>
                            <ListItemText
                                primary="契約条件・退去ルールの確認"
                                secondary="敷金・礼金、原状回復、解約通知期間などトラブルの元になりやすい部分は念入りにチェック。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><ErrorOutlineIcon color="error" /></ListItemIcon>
                            <ListItemText
                                primary="初対面の印象だけで決めない"
                                secondary="ルームメイト候補とは複数回話し、日常の価値観や生活リズムが合うかをしっかり確認。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><ErrorOutlineIcon color="error" /></ListItemIcon>
                            <ListItemText
                                primary="家財や荷物の断捨離は計画的に"
                                secondary="新居の収納や共用スペースに合わないものは思い切って処分・売却を。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><ErrorOutlineIcon color="error" /></ListItemIcon>
                            <ListItemText
                                primary="引っ越し時期の調整"
                                secondary="退去と入居のスケジュールがずれると、一時的な住まい探しや余計な費用が発生しやすいので要注意。"
                            />
                        </ListItem>
                    </List>
                </Paper>
                <Box
                    component="img"
                    src="/images/blog/moving-day_roomshare-sumikkae-taikendan.jpg"
                    alt="段ボール箱が積み重なった明るい玄関で、新しい生活にワクワクしながら荷物を運び入れる若者の姿。住み替えの一歩を踏み出す瞬間を象徴した写真"
                    sx={{ width: '100%', borderRadius: 2, mb: 2, boxShadow: 1 }}
                />
            </Box>

            {/* まとめ */}
            <Box id="summary" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    まとめ＆次のステップ
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    ルームシェアの住み替えは、環境や人間関係をリフレッシュし、自分らしい生き方に近づく大きなチャンスです。<br />
                    しっかりと情報収集し、目的や条件を明確にしたうえで、焦らず新しい一歩を踏み出しましょう。<br />
                    成功の秘訣は「自分の本当の希望に正直でいること」と、「小さな違和感も見逃さないこと」。<br />
                    この記事が、あなたの新しいスタートの参考になれば幸いです。
                </Typography>
                <Box sx={{ textAlign: 'center', mt: 3 }}>
                    <Button
                        variant="outlined"
                        size="large"
                        color="primary"
                        endIcon={<LaunchIcon />}
                        href="#"
                        sx={{ px: 4, py: 1.5, fontWeight: 'bold', borderRadius: 3 }}
                    >
                        ルームシェア住み替え物件を探す
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};

const post = {
    id: 'roomshare-sumikkae-taikendan',
    slug: 'roomshare-sumikkae-taikendan',
    title: 'ルームシェアの「住み替え」成功体験談',
    excerpt: '住み替えのきっかけ、住み替えのコツ、体験談、失敗しないポイントを実体験とともに徹底解説します。',
    coverImage: '/images/blog/cover-modern-shareliving_roomshare-sumikkae-taikendan.jpg',
    coverImageAlt: '明るい自然光が差し込むモダンなルームシェアの共有リビングで、多様な背景を持つルームメイトたちが楽しく会話をしている様子。ナチュラルなインテリアとカラフルなクッション、観葉植物がアクセントとなり、住み替え後の充実した共同生活を象徴している。',
    publishedAt: '2024-06-13T00:00:00.000Z',
    isPublished: true,
    categories: ['ルームシェア', '住み替え', '体験談'],
    tags: ['ルームシェア', '住み替え', '成功事例', 'トラブル回避', '引っ越し'],
    author: {
        name: '山田 理恵',
        avatar: '/images/avatars/yamada-rie.jpg',
        bio: 'ルームシェア歴10年以上。複数のシェアハウス運営・入居経験をもとに、住み替えや共同生活のノウハウを発信中。',
        profilePicture: '/images/avatars/yamada-rie.jpg'
    },
    viewCount: 1267,
    contentComponent: PostContent
};

export default post;